import {useParams} from "react-router-dom";
import AgForm from "../Forms/AgForm/AgForm";

interface FormEntry {
    formEntryId?: number;
    isAdminPreview?: boolean;
    formId?: number;
}
export default function AgFormEntry(props: FormEntry): JSX.Element {
    const { isAdminPreview, formEntryId, formId } = props;
    const { formEntryIdParams } = useParams();

    return <>
        <AgForm
            formId={formId}
            isAdminPreview={isAdminPreview}
            formEntryId={formEntryIdParams ? parseInt(formEntryIdParams) : formEntryId} />
    </>
}
